import CountUp from 'react-countup';
import { keyframes, styled } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
`;

export const HomeContainer = styled.div`
  width: 100%;
  overflow-x: hidden;
  position: relative;
  min-height: 100dvh;
  height: 100%;
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 100%;
  min-height: calc(100dvh - 122px);
  height: 100%;
  padding: 10rem 4rem;
  max-width: 150rem;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  gap: 2rem;
  @media (max-width: 430px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const StyledButton = styled.button`
  color: #fff;
  font-family: 'FrankfurterEF-Medium';
  font-size: 2.4rem;
  border-radius: 2rem;
  border: 2px solid #484888;
  background: ${props => (props.disabled ? '#e9e9e9' : '#484888')};
  width: fit-content;
  display: none;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  border: none;

  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  @media (max-width: 430px) {
    display: flex;
  }
`;

export const Button = styled.button`
  color: #fff;
  font-family: 'FrankfurterEF-Medium';
  font-size: 2.4rem;
  border-radius: 2rem;
  border: 2px solid #484888;
  background: ${props => (props.disabled ? '#e9e9e9' : '#484888')};
  display: flex;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  align-self: flex-end;
  width: fit-content;
  border: none;
  outline: none;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  @media (max-width: 430px) {
    display: none;
  }
`;
export const LoaderContainer = styled.div`
  background: white;
  height: calc(100dvh - 122px);
  width: 100%;
`;

export const HeaderWrapper = styled.header`
  background-color: #fff;

  z-index: 500;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.11);
  position: fixed;
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  top: 0;
`;

export const Card = styled.div`
  width: 16rem;
  height: 20rem;
  padding: 1.4rem;
  gap: 1rem;
  display: flex;
  flex-direction: column;

  border-radius: 1rem;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 6rem;
  height: 6rem;
  border-radius: 1rem;
  background-color: rgba(236, 195, 113, 0.2);
`;

export const Label = styled.span`
  font-family: 'Avenir-Medium';
  font-size: 1.2rem;
  letter-spacing: 0.067px;
`;

export const Time = styled.span`
  font-family: 'Avenir-Heavy';
  font-size: 3rem;
  letter-spacing: 0.067px;
`;

export const Value = styled(CountUp)`
  font-family: 'Avenir-Heavy';
  font-size: 3rem;
  letter-spacing: 0.067px;
`;

export const Icon = styled.img`
  width: 3.5rem;
  height: 3.5rem;
  user-select: none;
  pointer-events: none;
`;

export const EmojiContainer = styled.div`
  width: 5.9rem;
  height: 5.9rem;
  user-select: none;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4rem;
`;
